const pathnames = location.pathname.split("/");
pathnames.pop();
pathnames.pop();
pathnames.splice(0, 0, location.origin);
let _public = pathnames.join("/");

if (_public[_public.length - 1] === "/") {
    _public = _public.substring(0, _public.length - 1);
}
/**
 * 
 * @param {String} path: 文件在public目录下的相对路径, 需要以/开头 
 */
export default function (path) {
    return _public + path;
}